function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.002,
    viewBox: "0 0 18 14.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 27",
    d: "M21911.5 10780h-15a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5zm-1.018-7.479a1.227 1.227 0 0 0-1.27 1.266 1.276 1.276 0 0 0 2.553 0 1.233 1.233 0 0 0-1.283-1.265zm-7.127 0a1.23 1.23 0 0 0-1.275 1.266 1.278 1.278 0 0 0 2.557 0 1.232 1.232 0 0 0-1.282-1.265zm4.383.566a.338.338 0 0 1 .363.386v1.527h.639v-1.743a.644.644 0 0 0-.709-.731 1.013 1.013 0 0 0-.83.44.643.643 0 0 0-.672-.44 1.035 1.035 0 0 0-.787.38v-.319h-.637v2.413h.637v-1.622a.632.632 0 0 1 .5-.286.336.336 0 0 1 .363.386v1.522h.637v-1.627a.634.634 0 0 1 .496-.284zm-7.3-.506v2.419h.633v-1.595a.822.822 0 0 1 .594-.274.741.741 0 0 1 .176.017v-.622a1.057 1.057 0 0 0-.77.391v-.33zm-3.107-.918v3.337h.711v-1.182h.852a1.076 1.076 0 1 0 0-2.15zm13.154 2.832a.709.709 0 1 1 .623-.709.639.639 0 0 1-.626.714zm-7.127 0a.71.71 0 1 1 .617-.709.639.639 0 0 1-.62.714zm-4.559-1.309h-.758v-.9h.758a.45.45 0 1 1 0 .9z",
    transform: "translate(-21895.002 -10766)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoCodeIcon);
export default __webpack_public_path__ + "static/media/promo-code-icon.a69563a2.svg";
export { ForwardRef as ReactComponent };